import React from "react";
import propTypes from 'prop-types';
import styled from "styled-components";


const Hero = ({ children, ...rest}) => {
  const HeroWrapper = styled.div`
  .hero-container{
    @media(min-width: 1024px ){
      background: ${rest.color} url(${rest.isHomeHero ? rest.desktopImg : rest.img });
      background-repeat: no-repeat;
      background-position: right;
    }
    @media(min-width: 880px ) and (max-width: 1024px){
      background: ${rest.color} url(${rest.isHomeHero ? rest.tabletImg : rest.img });
      background-repeat: no-repeat;
      background-position: right;
    } 
    @media (max-width: 880px){
      background: ${rest.color} url("none");
    }
    background-repeat: no-repeat;
    background-position: right;
    @media (min-width: 880px){
      background-size: contain;
    }
    @media(min-width: 880px ) and (max-width: 1230px){
      background-size: cover;

    }
  }
  &.usa-hero{ 
    background-image: none;
    .usa-breadcrumb{
    @media(max-width: 1200px){
      padding-bottom: 0.15rem;
  }  
}
    .grid-container{
      @media (min-width: 880px){
        height: ${rest.isFixedHeight ? (rest.isHomeHero ? "430px" : "330px") : "auto" };
        padding-top: ${rest.isHomeHero ? "2rem" : "0"};
    }
    @media(min-width: 880px ) and (max-width: 1230px){
      height: ${rest.isFixedHeight ? (rest.isHomeHero ? "430px" : "330px") : "auto" };
    }
      //padding-top: ${rest.isHomeHero ? "2rem": "0"};
      @media(max-width: 1024px){
        //padding: 0;
        //min-height: 300px;
      }
      .usa-hero__callout{
        padding-top: ${rest.isHomeHero ? "4rem": "0"};
        padding-left: 0px;
        background-color: transparent;
        z-index: 1;
        @media(min-width: 640px){
          max-width: 45rem;
        }
        @media(min-width: 880px ) and (max-width: 1200px){
          h1{
            max-width: 38rem;
            margin-top: ${rest.isFixedHeight ? "0" : "30px" }
          }
          p{
            max-width: 30rem;

          }
          
        }
        @media(max-width: 1024px){
          padding-left: 1rem;
          padding-right: 1rem;
        }   
      }
  }
  .usa-button:visited {
    color: #2A5254;
}
}`;
  const HeroContent = styled.div`
    .usa-hero__heading{
      color: ${rest.headingColor}
    }
    &.usa-hero__callout, p, a{
      color: ${rest.textColor}
    }
`;
  return (   
    <HeroWrapper className="usa-hero">
      <div className="hero-container">
        <div className="grid-container">
          <div className="grid-row">
          <HeroContent className="usa-hero__callout">
              {children}
          </HeroContent>
          </div>
        </div>
      </div>
    </HeroWrapper>  
    )
}
export default Hero;

Hero.propTypes = { 
  textColor: propTypes.string,
  headingColor: propTypes.string,
  img: propTypes.string,
  color: propTypes.string,
  isHomeHero: propTypes.oneOf([true, false]),
  isFixedHeight: propTypes.oneOf([true, false]),
}
Hero.defaultProps = {
  textColor: '#333333',
  headingColor: '#383E56',
  img: '',
  color: '#fff',
  isHomeHero: false,
  isFixedHeight: true
}